import * as React from "react";
import { AbstractReactFactory } from "@projectstorm/react-canvas-core";

import { DefaultNodeModel } from "./DefaultNodeModel";
import { DefaultNodeWidget } from "./DefaultNodeWidget";
import { isNodeBranchingOutcomeAvailable } from "../../../../config/node/util";
import { BranchingOutcomeFailure, BranchingOutcomeSuccess } from "../../../../lib/playground/constants";

export class DefaultNodeFactory extends AbstractReactFactory {
	constructor () {
		super("default");
	}

	generateReactWidget (event) {
		const opts = event.model.getOptions();

		return (
			<DefaultNodeWidget
				engine={this.engine}
				node={event.model}
				right={isNodeBranchingOutcomeAvailable(opts, BranchingOutcomeSuccess)}
				bottom={isNodeBranchingOutcomeAvailable(opts, BranchingOutcomeFailure)}
				{...opts}
			/>
		);
	}

	generateModel (event) {
		return new DefaultNodeModel();
	}
}
